/**
 * @file wizard.js
 *
 * @fileoverview Configuration for application wizards.
 */
 const jobiqoWizardConfig = require('./../src/jobiqo/config/wizard');
 const R = require('ramda');
 module.exports = R.mergeDeepRight(jobiqoWizardConfig, {
   // Insert config here. this will be deep merged with config from jobiqo. Arrays are not deep mergeable
   // so make sure to cover those with [...jobiqoWizardConfig.public.SOME_KEY_THAT_IS_ARRAY, new_item ]
 });
